var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('codemirror', _vm._g(_vm._b({
    ref: "codemirror",
    staticClass: "core-codemirror",
    attrs: {
      "options": _vm.fullCmOptions,
      "value": _vm.value
    }
  }, 'codemirror', _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns = [];
export { render, staticRenderFns };